import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseDeleteInitialPublicOfferQueryType = {
  onSuccess?: UseMutationConfig<any>['onSuccess'];
  onReject?: UseMutationConfig<any>['onReject'];
};

export default function useDeleteInitialPublicOfferQuery({
  onReject,
  onSuccess,
}: UseDeleteInitialPublicOfferQueryType) {
  const { execute: deleteInitialOffer, ...query } = useMutation(
    (order: number) => API.deleteInitialPublicOffer(order),
    {
      onSuccess,
      onReject,
    }
  );

  return { deleteInitialOffer, ...query };
}
